<template>
  <!-- 项目进度表单 -->
  <el-form ref="form" :model="form1" label-width="100px">
    <el-row>
      <el-col span="6">
        <el-form-item label="所属模块" :required="true">
          <el-select
            clearable
            v-model="form.module"
            placeholder="请选择所属模块"
            filterable 
          >
            <el-option
              v-for="item in tboptions.module"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item label="类型" :required="true">
          <el-select clearable v-model="form.type" placeholder="请选择类型">
            <el-option
              v-for="item in tboptions.type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item label="任务序号">
          <el-input v-model="form.sqnum"></el-input>
        </el-form-item>
      </el-col>
      <el-col span="6" class="shzt" v-show="form.shzt">
        审核状态: <span>{{ form.shzt }}</span>
      </el-col>
    </el-row>
    <el-form-item label="任务明细">
      <el-input v-model="form.taskdetail" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-form-item label="任务说明">
      <el-input
        v-model="form.instructions"
        type="textarea"
        rows="20"
      ></el-input>
    </el-form-item>
    <el-row>
      <el-col span="7">
        <el-form-item label="周">
          <el-input-number v-model="form.week"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col span="15">
        <el-form-item label="计划日期">
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="form.bd"
              style="width: 100%;"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="form.ed"
              style="width: 100%;"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col span="7">
        <el-form-item label="持续天数">
          <el-input-number v-model="form.days"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col span="15">
        <el-form-item label="实际完成日期" label-width="125px">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="form.findate"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="状态">
      <!-- <el-input v-model="form.lx"></el-input> -->
      <el-select clearable v-model="form.status" placeholder="请选择状态">
        <el-option
          v-for="item in tboptions.status"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="延期原因">
      <el-input v-model="form.reason" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-row>
      <el-col span="7">
        <el-form-item label="负责人" :required="true">
          <el-input v-model="form.fzr"></el-input>
          <!-- <el-select clearable  v-model="form.fzr" placeholder="请选择负责人">
            <el-option
              v-for="item in tboptions.fzr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </el-col>
      <el-col span="7">
        <el-form-item label="需要研发协助">
          <el-switch v-model="form.kf"></el-switch>
        </el-form-item>
      </el-col>
      <!-- <el-col span="7">
        <el-form-item label="是否调研">
          <el-switch v-model="form.dy"></el-switch>
        </el-form-item>
      </el-col> -->
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    tboptions: {
      // 下拉选项
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      form1: {}
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-form {
  height: calc(100vh - 250px);
  overflow-y: auto;
  .shzt {
    height: 42px;
    line-height: 42px;
    padding: 0 20px;
    font-weight: bold;
    span {
      color: #1b6aaa;
    }
  }
  /deep/ .el-form-item {
    .el-form-item__label {
      font-weight: bold;
    }
  }
}
</style>
